export default "__VITE_ASSET__BOIIpBxg__"